var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyInformationValues(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 387,
    height: 369,
    "aria-labelledby": titleId,
    viewBox: "0 0 387 369",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#clip-path)",
    style: {
      fill: "url(\"#fill\")"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 0,
    ry: 0,
    width: 196,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53,
    rx: 0,
    ry: 0,
    width: 78,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80,
    rx: 0,
    ry: 0,
    width: 193,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106,
    rx: 0,
    ry: 0,
    width: 121,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 132,
    rx: 0,
    ry: 0,
    width: 193,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 159,
    rx: 0,
    ry: 0,
    width: 111,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 185,
    rx: 0,
    ry: 0,
    width: 253,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212,
    rx: 0,
    ry: 0,
    width: 111,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 238,
    rx: 0,
    ry: 0,
    width: 253,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 265,
    rx: 0,
    ry: 0,
    width: 111,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 291,
    rx: 0,
    ry: 0,
    width: 293,
    height: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599964,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.59996,
    stopColor: "#96abba",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.59996,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInformationValues);
export default __webpack_public_path__ + "static/media/company_information_values.f14a713ac9e8d2ac7a34e1504506f268.svg";
export { ForwardRef as ReactComponent };